import { IconsDataProps } from './icon.type'
import * as Icons from '@components/icons'

export const ICONS_DATA: IconsDataProps = [
  {
    slug: 'accordion',
    icon: <Icons.Accordion width="20" />,
    code: `<Accordion width="20" />`,
    title: 'Accordion',
  },
  { slug: 'adjustment', icon: <Icons.Adjustment width="20" />, code: `<Adjustment width="20" />`, title: 'Adjustment' },
  //   { slug: 'alert', icon: <Icons.Alert width='20' />, code:``,title: 'Alert' },
  { slug: 'arrow-down', icon: <Icons.ArrowDown width="20" />, code: `<ArrowDown width="20" />`, title: 'ArrowDown' },
  {
    slug: 'arrow-top',
    icon: <Icons.ArrowDown direction="top" width="20" />,
    code: `<ArrowDown direction="top" width="20" />`,
    title: 'ArrowUp',
  },
  {
    slug: 'arrow-right',
    icon: <Icons.ArrowDown direction="right" width="20" />,
    code: `<ArrowDown direction="right" width="20" />`,
    title: 'ArrowRight',
  },
  {
    slug: 'arrow-left',
    icon: <Icons.ArrowDown direction="left" width="20" />,
    code: `<ArrowDown direction="left" width="20" />`,
    title: 'ArrowDown',
  },
  {
    slug: 'arrow-right-bottom',
    icon: <Icons.ArrowDown direction="right-bottom" width="20" />,
    code: `<ArrowDown direction="right-bottom" width="20" />`,
    title: 'ArrowDownRight',
  },
  {
    slug: 'arrow-left-bottom',
    icon: <Icons.ArrowDown direction="left-bottom" width="20" />,
    code: `<ArrowDown direction="left-bottom" width="20" />`,
    title: 'ArrowDownLeft',
  },
  {
    slug: 'arrow-right-top',
    icon: <Icons.ArrowDown direction="right-top" width="20" />,
    code: `<ArrowDown direction="right-top" width="20" />`,
    title: 'ArrowDown',
  },
  {
    slug: 'arrow-left-top',
    icon: <Icons.ArrowDown direction="left-top" width="20" />,
    code: `<ArrowDown direction="left-top" width="20" />`,
    title: 'ArrowDown',
  },
  { slug: 'bell', icon: <Icons.Bell width="20" />, code: `<Bell width="20" />`, title: 'Bell' },
  { slug: 'billiard', icon: <Icons.Billiard width="20" />, code: `<Billiard width="20" />`, title: 'Billiard' },
  { slug: 'bold', icon: <Icons.Bold width="20" />, code: `<Bold width="20" />`, title: 'Bold' },
  { slug: 'box-margin', icon: <Icons.BoxMargin width="20" />, code: `<BoxMargin width="20" />`, title: 'BoxMargin' },
  { slug: 'calender', icon: <Icons.Calendar width="20" />, code: `<Calendar width="20" />`, title: 'Calendar' },
  { slug: 'camera', icon: <Icons.Camera width="20" />, code: `<Camera width="20" />`, title: 'Camera' },
  { slug: 'card', icon: <Icons.Card width="20" />, code: `<Card width="20" />`, title: 'Card' },
  {
    slug: 'caret-top',
    icon: <Icons.Caret direction="top" width="20" />,
    code: `<Caret direction="top" width="20" />`,
    title: 'CaretTop',
  },
  {
    slug: 'caret-right',
    icon: <Icons.Caret direction="right" width="20" />,
    code: `<Caret direction="right" width="20" />`,
    title: 'CaretRight',
  },
  {
    slug: 'caret-down',
    icon: <Icons.Caret direction="bottom" width="20" />,
    code: `<Caret direction="bottom" width="20" />`,
    title: 'CaretDown',
  },
  {
    slug: 'caret-left',
    icon: <Icons.Caret direction="left" width="20" />,
    code: `<Caret direction="left" width="20" />`,
    title: 'CaretLeft',
  },
  { slug: 'cart', icon: <Icons.Cart width="20" />, code: ``, title: 'Cart' },
  { slug: 'chart', icon: <Icons.Chart width="20" />, code: ``, title: 'Chart' },
  { slug: 'check', icon: <Icons.Check width="20" />, code: ``, title: 'Check' },
  { slug: 'checkbox', icon: <Icons.Checkbox width="20" />, code: ``, title: 'Checkbox' },
  {
    slug: 'chevron-top',
    icon: <Icons.ChevronDown direction="top" width="20" />,
    code: `<ChevronDown direction="top" width="20" />`,
    title: 'ChevronTop',
  },
  {
    slug: 'chevron-right',
    icon: <Icons.ChevronDown direction="right" width="20" />,
    code: `<ChevronDown direction="right" width="20" />`,
    title: 'ChevronRight',
  },
  {
    slug: 'chevron-down',
    icon: <Icons.ChevronDown direction="bottom" width="20" />,
    code: `<ChevronDown direction="bottom" width="20" />`,
    title: 'ChevronDown',
  },
  {
    slug: 'chevron-left',
    icon: <Icons.ChevronDown direction="left" width="20" />,
    code: `<ChevronDown direction="left" width="20" />`,
    title: 'ChevronLeft',
  },
  {
    slug: 'circle-check',
    icon: <Icons.CircleCheck width="20" />,
    code: `<CircleCheck width="20" />`,
    title: 'CircleCheck',
  },
  {
    slug: 'circle-cross',
    icon: <Icons.CircleCross width="20" />,
    code: `<CircleCross width="20" />`,
    title: 'CircleCross',
  },
  {
    slug: 'circle-dashed',
    icon: <Icons.CircleDashed width="20" />,
    code: `<CircleDashed width="20" />`,
    title: 'CircleDashed',
  },
  { slug: 'circle-dot', icon: <Icons.CircleDot width="20" />, code: `<CircleDot width="20" />`, title: 'CircleDot' },
  {
    slug: 'circle-plus',
    icon: <Icons.CirclePlus width="20" />,
    code: `<CirclePlus width="20" />`,
    title: 'CirclePlus',
  },
  {
    slug: 'circle-refresh',
    icon: <Icons.CircleRefresh width="20" />,
    code: `<CircleRefresh width="20" />`,
    title: 'CircleRefresh',
  },
  { slug: 'clock', icon: <Icons.Clock width="20" />, code: `<Clock width="20" />`, title: 'Clock' },
  {
    slug: 'close-switch',
    icon: <Icons.ClosedSwitch width="20" />,
    code: `<ClosedSwitch width="20" />`,
    title: 'ClosedSwitch',
  },
  {
    slug: 'cloud-upload',
    icon: <Icons.CloudUpload width="20" />,
    code: `<CloudUpload width="20" />`,
    title: 'CloudUpload',
  },
  { slug: 'code', icon: <Icons.Code width="20" />, code: `<Code width="20" />`, title: 'Code' },
  { slug: 'columns', icon: <Icons.Columns width="20" />, code: `<Columns width="20" />`, title: 'Columns' },
  { slug: 'component', icon: <Icons.Component width="20" />, code: `<Component width="20" />`, title: 'Component' },
  { slug: 'cross', icon: <Icons.Cross width="20" />, code: `<Cross width="20" />`, title: 'Cross' },
  { slug: 'crown', icon: <Icons.Crown width="20" />, code: `<Crown width="20" />`, title: 'Crown' },
  { slug: 'dislike', icon: <Icons.Dislike width="20" />, code: `<Dislike width="20" />`, title: 'Dislike' },
  { slug: 'dollar', icon: <Icons.Dollar width="20" />, code: `<Dollar width="20" />`, title: 'Dollar' },
  { slug: 'dots', icon: <Icons.Dots width="20" />, code: `<Dots width="20" />`, title: 'Dots' },
  {
    slug: 'double-check',
    icon: <Icons.DoubleCheck width="20" />,
    code: `<DoubleCheck width="20" />`,
    title: 'DoubleCheck',
  },
  { slug: 'envelop', icon: <Icons.Envelop width="20" />, code: `<Envelop width="20" />`, title: 'Envelop' },
  { slug: 'eye', icon: <Icons.Eye width="20" />, code: `<Eye width="20" />`, title: 'Eye' },
  { slug: 'eye-off', icon: <Icons.EyeOff width="20" />, code: `<EyeOff width="20" />`, title: 'Eye Off' },
  { slug: 'float-left', icon: <Icons.FLoatLeft width="20" />, code: `<FLoatLeft width="20" />`, title: 'FloatLeft' },
  { slug: 'forms', icon: <Icons.Forms width="20" />, code: `<Forms width="20" />`, title: 'Forms' },
  { slug: 'face', icon: <Icons.Face width="20" />, code: `<Face width="20" />`, title: 'Face' },
  { slug: 'facebook', icon: <Icons.Facebook width="20" />, code: `<Facebook width="20" />`, title: 'Facebook' },
  {
    slug: 'file-upload',
    icon: <Icons.FileUpload width="20" />,
    code: `<FileUpload width="20" />`,
    title: 'FileUpload',
  },
  { slug: 'filter', icon: <Icons.Filter width="20" />, code: `<Filter width="20" />`, title: 'Filter' },
  { slug: 'github', icon: <Icons.Github width="20" />, code: `<Github width="20" />`, title: 'Github' },
  { slug: 'globe', icon: <Icons.Globe width="20" />, code: `<Globe width="20" />`, title: 'Globe' },
  { slug: 'gmail', icon: <Icons.Gmail width="20" />, code: `<Gmail width="20" />`, title: 'Gmail' },
  {
    slug: 'hand-finger',
    icon: <Icons.HandFinger width="20" />,
    code: `<HandFinger width="20" />`,
    title: 'HandFinger',
  },
  { slug: 'heart', icon: <Icons.Heart width="20" />, code: `<Heart width="20" />`, title: 'Heart' },
  { slug: 'help', icon: <Icons.Help width="20" />, code: `<Help width="20" />`, title: 'Help' },
  { slug: 'home', icon: <Icons.Home width="20" />, code: `<Home width="20" />`, title: 'Home' },
  { slug: 'info', icon: <Icons.Info width="20" />, code: `<Info width="20" />`, title: 'Info' },
  {
    slug: 'info-circle',
    icon: <Icons.InfoCircle type="circle" width="20" />,
    code: `<InfoCircle type="circle" width="20" />`,
    title: 'InfoCircle',
  },
  { slug: 'layer', icon: <Icons.Layer width="20" />, code: `<Layer width="20" />`, title: 'Layer' },
  {
    slug: 'layout-grid',
    icon: <Icons.LayoutGrid width="20" />,
    code: `<LayoutGrid width="20" />`,
    title: 'LayoutGrid',
  },
  { slug: 'layout-row', icon: <Icons.LayoutRow width="20" />, code: `<LayoutRow width="20" />`, title: 'LayoutRow' },
  {
    slug: 'letter-case',
    icon: <Icons.LetterCase width="20" />,
    code: `<LetterCase width="20" />`,
    title: 'LetterCase',
  },
  { slug: 'like', icon: <Icons.Like width="20" />, code: `<Like width="20" />`, title: 'Like' },
  { slug: 'link', icon: <Icons.Link width="20" />, code: `<Link width="20" />`, title: 'Link' },
  { slug: 'linkdin', icon: <Icons.Linkdin width="20" />, code: `<Linkdin width="20" />`, title: 'Linkdin' },
  { slug: 'list', icon: <Icons.List width="20" />, code: `<List width="20" />`, title: 'List' },
  { slug: 'loader', icon: <Icons.Loader width="20" />, code: `<Loader width="20" />`, title: 'Loader' },
  { slug: 'mail', icon: <Icons.Mail width="20" />, code: `<Mail width="20" />`, title: 'Mail' },
  { slug: 'mask', icon: <Icons.Mask width="20" />, code: `<Mask width="20" />`, title: 'Mask' },
  { slug: 'maximize', icon: <Icons.Maximize width="20" />, code: `<Maximize width="20" />`, title: 'Maximize' },
  { slug: 'menu', icon: <Icons.Menu width="20" />, code: `<Menu width="20" />`, title: 'Menu' },
  { slug: 'message', icon: <Icons.Message width="20" />, code: `<Message width="20" />`, title: 'Message' },
  {
    slug: 'message-plus',
    icon: <Icons.MessagePlus width="20" />,
    code: `<MessagePlus width="20" />`,
    title: 'MessagePlus',
  },
  { slug: 'messages', icon: <Icons.Messages width="20" />, code: `<Messages width="20" />`, title: 'Messages' },
  { slug: 'minimize', icon: <Icons.Minimize width="20" />, code: `<Minimize width="20" />`, title: 'Minimize' },
  { slug: 'moon', icon: <Icons.Moon width="20" />, code: `<Moon width="20" />`, title: 'Moon' },
  { slug: 'not-found', icon: <Icons.NotFound width="20" />, code: `<NotFound width="20" />`, title: 'NotFound' },
  { slug: 'note', icon: <Icons.Note width="20" />, code: `<Note width="20" />`, title: 'Note' },
  { slug: 'pen', icon: <Icons.Pen width="20" />, code: `<Pen width="20" />`, title: 'Pen' },
  { slug: 'percentage', icon: <Icons.Percentage width="20" />, code: `<Percentage width="20" />`, title: 'Percentage' },
  { slug: 'phone', icon: <Icons.Phone width="20" />, code: `<Phone width="20" />`, title: 'Phone' },
  { slug: 'plus', icon: <Icons.Plus width="20" />, code: `<Plus width="20" />`, title: 'Plus' },
  { slug: 'pointer', icon: <Icons.Pointer width="20" />, code: `<Pointer width="20" />`, title: 'Pointer' },
  {
    slug: 'report-analytics',
    icon: <Icons.ReportAnalytics width="20" />,
    code: `<ReportAnalytics width="20" />`,
    title: 'ReportAnalytics',
  },
  { slug: 'search', icon: <Icons.Search width="20" />, code: `<Search width="20" />`, title: 'Search' },
  { slug: 'send', icon: <Icons.Send width="20" />, code: `<Send width="20" />`, title: 'Send' },
  { slug: 'settings', icon: <Icons.Setting width="20" />, code: `<Setting width="20" />`, title: 'Setting' },
  { slug: 'share', icon: <Icons.Share width="20" />, code: `<Share width="20" />`, title: 'Share' },
  {
    slug: 'shield-check',
    icon: <Icons.ShieldCheck width="20" />,
    code: `<ShieldCheck width="20" />`,
    title: 'ShieldCheck',
  },
  { slug: 'ship', icon: <Icons.Ship width="20" />, code: `<Ship width="20" />`, title: 'Ship' },
  { slug: 'stack', icon: <Icons.Stack width="20" />, code: `<Stack width="20" />`, title: 'Stack' },
  { slug: 'star', icon: <Icons.Star width="20" />, code: `<Star width="20" />`, title: 'Star' },
  { slug: 'sun', icon: <Icons.Sun width="20" />, code: `<Sun width="20" />`, title: 'Sun' },
  { slug: 'switch', icon: <Icons.Switches width="20" />, code: `<Switches width="20" />`, title: 'Switch' },
  { slug: 'tag', icon: <Icons.Tag width="20" />, code: `<Tag width="20" />`, title: 'Tag' },
  { slug: 'template', icon: <Icons.Template width="20" />, code: `<Template width="20" />`, title: 'Template' },
  { slug: 'thumbUp', icon: <Icons.ThumbUp width="20" />, code: `<ThumbUp width="20" />`, title: 'ThumbUp' },
  { slug: 'toggle', icon: <Icons.Toggle width="20" />, code: `<Toggle width="20" />`, title: 'Toggle' },
  { slug: 'trash', icon: <Icons.Trash width="20" />, code: `<Trash width="20" />`, title: 'Trash' },
  { slug: 'twitter', icon: <Icons.Twitter width="20" />, code: `<Twitter width="20" />`, title: 'Twitter' },
  { slug: 'user', icon: <Icons.User width="20" />, code: `<User width="20" />`, title: 'User' },
  {
    slug: 'user-circle',
    icon: <Icons.UserCircle width="20" />,
    code: `<UserCircle width="20" />`,
    title: 'UserCircle',
  },
  { slug: 'users', icon: <Icons.Users width="20" />, code: `<Users width="20" />`, title: 'Users' },
  { slug: 'user-x', icon: <Icons.UserX width="20" />, code: `<UserX width="20" />`, title: 'UserX' },
  { slug: 'video', icon: <Icons.Video width="20" />, code: `<Video width="20" />`, title: 'Video' },
  { slug: 'lock', icon: <Icons.Vocabulary width="20" />, code: `<Vocabulary width="20" />`, title: 'Lock' },
  { slug: 'volume', icon: <Icons.Volume width="20" />, code: `<Volume width="20" />`, title: 'Volume' },
  { slug: 'volume-off', icon: <Icons.VolumeOff width="20" />, code: `<VolumeOff width="20" />`, title: 'VolumeOff' },
  { slug: 'warning', icon: <Icons.Warning width="20" />, code: `<Warning width="20" />`, title: 'Warning' },
  { slug: 'world', icon: <Icons.World width="20" />, code: `<World width="20" />`, title: 'World' },
  { slug: 'writing', icon: <Icons.Writing width="20" />, code: `<Writing width="20" />`, title: 'Writing' },
  { slug: 'zoom-in', icon: <Icons.ZoomIn width="20" />, code: `<ZoomIn width="20" />`, title: 'zoomIn' },
  { slug: 'zoom-out', icon: <Icons.ZoomOut width="20" />, code: `<ZoomOut width="20" />`, title: 'zoomOut' },
]
